import { forwardRef, KeyboardEvent } from 'react';
import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';

interface SearchBarProps {
  query: string;
  setQuery: (query: string) => void;
  setShowSuggestions: (show: boolean) => void;
  handleSearch: () => void;
}

const SearchBar = forwardRef<HTMLInputElement, SearchBarProps>(
  ({ query, setQuery, setShowSuggestions, handleSearch }, ref) => {
    const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
      if (e.key === 'Enter') {
        handleSearch();
      }
    };

    return (
      <div className="relative w-full">
        <Input
          ref={ref}
          type="text"
          placeholder="Search for projects"
          value={query}
          onChange={(e) => {
            setQuery(e.target.value);
            setShowSuggestions(true);
          }}
          onFocus={() => setShowSuggestions(true)}
          onKeyDown={handleKeyDown}
          className="pr-10 w-full"
        />
        <div
          className="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer"
          onClick={handleSearch}
          onKeyDown={handleKeyDown}
          role="button"
          tabIndex={0}
          aria-label="Search"
        >
          <Search className="h-4 w-4 text-black-400 hover:text-black-600" />
        </div>
      </div>
    );
  }
);

SearchBar.displayName = 'SearchBar';

export default SearchBar;
